export default __webpack_public_path__ + "static/media/skydancer.f62cc4bd.png";